import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAPI from "@/app/api/auth/authentication"
import MyAccountAPI from "@/app/api/customer-dashboard/my-account"
import CryptoHelper from "@/app/utils/crypto"
import { removeCookies } from "@/app/utils/helpers"
import Cookies from "js-cookie"
const authApi = new AuthAPI()
const myAccountApi = new MyAccountAPI()
const cryptoHelper = new CryptoHelper()

export const regisUser = createAsyncThunk("auth/regisUser",
  async (credentials, thunkAPI) => {
    try {
      const { data } = await authApi.registerUser(credentials)
      return { ...data, data: credentials }
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message)
    }
  }
)

export const verifyRegistry = createAsyncThunk("auth/verifyRegistry",
  async (credentials, thunkAPI) => {
    try {
      const { data } = await authApi.verifyUser(credentials)
      return data
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message)
    }
  }
)

export const logIn = createAsyncThunk("auth/logIn",
  async (credentials, thunkAPI) => {
    try {
      const { data } = await authApi.logInUser(credentials)
      return data
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message)
    }
  }
)

export const updateUser = createAsyncThunk("auth/updateUser",
  async (credentials, thunkAPI) => {
    try {
      const { data } = await myAccountApi.updateUserDetail(credentials)
      return { ...data, data: credentials }
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message)
    }
  }
)

export const logOut = createAsyncThunk("auth/logOut",
  async (_, thunkAPI) => {
    try {
      const { data } = await authApi.logOutUser()
      return data
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message)
    }
  }
)

export const forgotPassword = createAsyncThunk("auth/forgotPassword",
  async (credentials, thunkAPI) => {
    try {
      const { data } = await authApi.sendEmailForgotPass(credentials)
      return data
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message)
    }
  }
)

export const resetPassword = createAsyncThunk("auth/resetPassword",
  async (credentials, thunkAPI) => {
    try {
      const { data } = await authApi.resetPass(credentials)
      return data
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data || err.message)
    }
  }
)

const initialState = {
  isAuth: !!Cookies.get("accessToken"),
  status: "idle",
  token: Cookies.get("accessToken") || null,
  user: Cookies.get("user") ? cryptoHelper.decrypt(Cookies.get("user")) : null,
  registered: null,
  reqEmail: false,
  error: null
}

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setReqEmail: (state, { payload }) => {
      state.reqEmail = payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(logIn.pending, (state) => {
        state.status = "loading"
      })
      .addCase(logIn.fulfilled, (state, { payload }) => {
        state.status = "succeeded"
        state.token = payload.data.token
        state.user = payload.data.user
        state.isAuth = true
      })
      .addCase(logIn.rejected, (state, { payload }) => {
        state.status = "failed"
        state.error = payload
      })
      .addCase(logOut.pending, (state) => {
        state.status = "loading"
      })
      .addCase(logOut.fulfilled, (state, { payload }) => {
        state.status = "succeeded"
        state.isAuth = false

        removeCookies()
      })
      .addCase(logOut.rejected, (state, { payload }) => {
        state.status = "failed"
        state.error = payload
      })
      .addCase(regisUser.pending, (state) => {
        state.status = "loading"
      })
      .addCase(regisUser.fulfilled, (state, { payload }) => {
        state.status = "succeeded"
        state.registered = payload.data
      })
      .addCase(regisUser.rejected, (state, { payload }) => {
        state.status = "failed"
        state.error = payload
      })
      .addCase(verifyRegistry.pending, (state) => {
        state.status = "loading"
      })
      .addCase(verifyRegistry.fulfilled, (state, { payload }) => {
        state.status = "succeeded"
      })
      .addCase(verifyRegistry.rejected, (state, { payload }) => {
        state.status = "failed"
        state.error = payload
      })
      .addCase(resetPassword.pending, (state) => {
        state.status = "loading"
      })
      .addCase(resetPassword.fulfilled, (state, { payload }) => {
        state.status = "succeeded"
        state.reqEmail = false
      })
      .addCase(resetPassword.rejected, (state, { payload }) => {
        state.status = "failed"
        state.error = payload
      })
      .addCase(forgotPassword.pending, (state) => {
        state.status = "loading"
      })
      .addCase(forgotPassword.fulfilled, (state, { payload }) => {
        state.status = "succeeded"
        state.reqEmail = true
      })
      .addCase(forgotPassword.rejected, (state, { payload }) => {
        state.status = "failed"
        state.error = payload
      })
      .addCase(updateUser.pending, (state) => {
        state.status = "loading"
      })
      .addCase(updateUser.fulfilled, (state, { payload }) => {
        state.status = "succeeded"
        // state.user = { id: payload.data.id, name: payload.data.name }        
        state.isAuth = true
      })
      .addCase(updateUser.rejected, (state, { payload }) => {
        state.status = "failed"
        state.error = payload
      })
  }
})

export const { setReqEmail } = authSlice.actions
export default authSlice.reducer
